import { useTranslation } from "react-i18next"
import "./entrepriseCard.css"
import allowedImageFileType from "../../valueContol/allowedImageFileType.json"
import { enumDocumentCategorie } from "../../enums/enumDocumentCategorie";
import { FileUploader } from "../fileUploader/fileUploader";

export const EntrepriseEntityCard = (props) => {
    const { t } = useTranslation()

    const saveEntityCardEntreprise = (entreprise) => {
        props.setEntreprise(entreprise, "entreprise")
    }

    return (
        <div className="ec-container dip-ta-center">
            <FileUploader
                className="personnal-info-file-container"
                fileName="logoEntrepriseFile"
                documentName="logo"
                entity={props.entreprise}
                setEntity={e => saveEntityCardEntreprise(e)}
                maxFileSize={10000000}
                flavorText="Logo de l'entreprise"
                tooltip={t('profile.square_maxMo', { size: 10000000 / 1000000 })}
                hasPreview={true}
                accept=".png,.jpg,.jpeg"
                allowedType={allowedImageFileType}
                documentCategory={enumDocumentCategorie.LOGOENTREPRISESTRUCTURE}
                isLight
            />
            <h1>
                {props.entreprise.nom}
            </h1>
            <h2>
                {props.entreprise.secteurActivite}
            </h2>
        </div>
    )
}